<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_advanced"></Header>
    <v-container fluid v-if="userMenu">
      <v-layout row wrap justify-center>
        <v-flex
          v-for="(subMenu, index) in userMenu.menu.submenu"
          :key="subMenu['@attributes'].txtid + index"
          xs12
          md6
          class="px-4 panel-block"
        >
          <sub-menu
            v-if="subMenu && userMenuData"
            :sub-menu="subMenu"
            :sub-menu-data="userMenuData"
            :sub-menu-output-setting="filteredOutputSettings"
            :show-helpdialog="false"
          ></sub-menu>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import SubMenu from "../components/SubMenu";
import GlobalService from "../services/global-service";

export default {
  components: {
    Header,
    SubMenu
  },
  data: () => ({
    userMenu: undefined,
    userMenuData: undefined,
    alertToggle: false,
    outputSettings: undefined,
    filteredOutputSettings: []
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userMenu = await GlobalService.getMenu(
        "advanced",
        this.getUser.token
      );
      this.userMenuData = await GlobalService.getMenuData(
        "advanced",
        this.getUser.token
      );
      this.$store.commit("global/setLoading", false);
    }
  }
};
</script>
